



















































































import { Vue, Component } from 'vue-property-decorator';
import { UserLogin } from '../../common/types';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import errorModule from '../../store/modules/error.module';
import budtenderModule from '../../store/modules/budtender.module';
import { BRAND_LOGIN_PAGE } from '../../common/routes.config';

@Component
export default class LoginPage extends Vue {
  login: UserLogin = { email: '', password: '' };

  initiatePasswordResetDialog = false;

  brandLogin = BRAND_LOGIN_PAGE;

  userEmail = '';

  async submitLogin(): Promise<void> {
    if (this.login.password.length < 6) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'Password must be at least 6 characters long.',
      );
      return;
    }
    if (this.login.email.length < 4) {
      eventBus.$emit(SHOW_SNACKBAR, 'Invalid email address.');
      return;
    }
    await budtenderModule.budtenderLogin(this.login);
    if (errorModule.hasError) {
      errorModule.clearError();
    }
  }

  triggerForgotPasswordDialog() {
    this.userEmail = this.login.email;
    this.initiatePasswordResetDialog = true;
  }

  async sendForgotPassword() {
    // Validate the email address
    if (
      !this.userEmail
      || this.userEmail.length < 5
      || !this.userEmail.includes('@')
    ) {
      eventBus.$emit(SHOW_SNACKBAR, 'Please enter a valid email address.');
      return;
    }
    this.initiatePasswordResetDialog = false;
    await budtenderModule.initiateBudtenderPasswordReset({ email: this.userEmail });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(
      SHOW_SNACKBAR,
      'Password reset link sent, please check your email.',
    );
  }
}
